
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ICollectionReporter } from '@/types/reporter-types'
import reporterService from '@/services/reporter-service'
import { ElForm } from 'element-ui/types/form'

@Component
export default class extends Vue {
    @Prop({ type: Boolean, default: false }) private show!: boolean
    @Prop({ type: Object, default: {} }) private reporter!: Object
    @Prop({ type: String, required: true }) private type!: string

    private centerDialogVisible: boolean = true
    private pageSize: number = 10
    private pageIndex: number = 1
    private pageTotal: number = 0
    private reporterInfo: ICollectionReporter = { id: -1, order: '', note: '', name: '' }
    private nameKeyword: string = ''
    private reporters: any[] = []
    private tipMsg = '等待搜索'
    private isLoading: boolean = false
    private formRules = {
        name: {
            type: 'string',
            // 只要输入的不是关键字，则不会自动触发校验
            trigger: 'false',
            required: true,
            validator: this.nameValidator
        },
        order: [
            { type: 'number', required: true, trigger: 'blur', message: '请输入正确的顺序' },
            { type: 'number', min: 1, message: '最小输入为1' }
        ],
        note: {
            message: '请输入正确的简介，并不能超过100个字',
            max: 100,
            trigger: 'blur'
        }
    }
    private selectReporter: boolean = false

    get title(): string {
        return this.type === 'add' ? '添加记者' : '修改记者'
    }

    @Emit('submit')
    private handleSubmit(formName: string): ICollectionReporter {
        const reporterInfo = JSON.stringify(this.reporterInfo)
        this.handleDialogOp(formName)
        return JSON.parse(reporterInfo)
    }

    @Emit('update:show')
    private handleDialogCancel(): boolean {
        return false
    }

    private nameValidator(rule: any, value: any, callback: any) {
        let _repoter: ICollectionReporter = this.reporterInfo
        if (!_repoter.id || _repoter.id === -1) {
            return callback('请输入正确的记者名')
        }
        callback()
    }

    private onAfterDialogClose(formName: string) {
        if (this.selectReporter) {
            this.selectReporter = false
            return
        }
        this.handleDialogOp(formName)
    }

    private submitForm(formName: string): void | boolean {
        (this.$refs[formName] as ElForm).validate((valid: boolean) => {
            valid && this.handleSubmit(formName)
        })
    }

    private handleDialogOp(formName: string): void {
        this.handleDialogCancel()
        ;(this.$refs[formName] as ElForm).clearValidate()
        this.reporterInfo = { id: -1, order: '', note: '', name: '' }
    }

    private onSelectReporterFocus() {
        this.selectReporter = true
        this.nameKeyword = this.reporterInfo.name
    }

    private handleDialogOpen() {
        if (this.type === 'edit') {
            this.reporterInfo = this.reporter as ICollectionReporter
        }
        this.$refs.reporterForm && (this.$refs.reporterForm as ElForm).clearValidate()
    }

    // 记者搜索
    private async reporterSearch() {
        (this.$refs.backTop as any).scrollToTop()
        this.isLoading = true
        const params = {
            keyword: this.nameKeyword,
            page_size: this.pageSize,
            page_index: this.pageIndex
        }
        const result = await reporterService.search(params)
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total || 0
            this.reporters = result.data.reporters || []
            if (!this.reporters.length) {
                this.tipMsg = '暂无数据'
            }
        }
    }

    private onPageChange(pageIndex: number) {
        this.pageIndex = pageIndex
        this.reporterSearch()
    }

    private onNavigateBack() {
        if (!this.selectReporter) {
            return
        }
        this.resetReporterSelect()
        this.selectReporter = false
    }

    private resetReporterSelect() {
        this.reporters = []
        this.selectReporter = false
        this.tipMsg = '等待搜索'
        this.nameKeyword = ''
    }

    private onReporterItemTap(item: any) {
        this.reporterInfo.id = item.id
        this.reporterInfo.name = item.name
        this.resetReporterSelect()
    }

    private afterSelectEnter() {
        if (this.selectReporter) {
            (this.$refs.reporterInput as any).focus()
        }
    }
}
